export default __webpack_public_path__ + "static/media/bg-img3.a0746858.jpg";